import React, { useState, useEffect } from 'react';
import styles from '../../../../../../styles/OverviewTab.module.css';

interface StatCardProps {
  title: string;
  value: number;
  icon: React.ReactNode;
  changeText: string;
  changeType?: 'positive' | 'neutral' | 'negative';
  suffix?: string;
}

const AnimatedNumber: React.FC<{ value: number; duration?: number }> = ({ value, duration = 1500 }) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    let startTime: number | null = null;
    const startValue = 0;
    const endValue = value;
    const difference = endValue - startValue;

    const animate = (currentTime: number) => {
      if (startTime === null) {
        startTime = currentTime;
      }

      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentValue = Math.round(startValue + difference * easeOutQuart);

      setDisplayValue(currentValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setDisplayValue(endValue);
      }
    };

    requestAnimationFrame(animate);
  }, [value, duration]);

  return <span>{displayValue.toLocaleString()}</span>;
};

const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  icon, 
  changeText, 
  changeType = 'positive',
  suffix = ''
}) => {
  return (
    <div className={styles.statCard}>
      <div className={styles.statHeader}>
        <span className={styles.statTitle}>{title}</span>
        <div className={styles.statIcon}>{icon}</div>
      </div>
      <div className={styles.statValue}>
        <AnimatedNumber value={value} />
        {suffix}
      </div>
      <div className={`${styles.statChange} ${styles[changeType]}`}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="23,6 13.5,15.5 8.5,10.5 1,18"></polyline>
          <polyline points="17,6 23,6 23,12"></polyline>
        </svg>
        {changeText}
      </div>
    </div>
  );
};

export default StatCard;

